<template>
  <div class="input-step w-100 step-primary">
    <button
      class="btn btn-primary minus material-shadow"
      @click.prevent="decrement"
      :disabled="internalValue <= min"
    >
      –
    </button>

    <input
      type="number"
      class="flex-grow-1"
      :class="{ 'is-invalid': isInvalid }"
      :value="internalValue"
      :readonly="readonly"
      @input="onInput"

    />

    <button
      class="btn btn-primary plus material-shadow"
      @click.prevent="increment"
      :disabled="internalValue >= max"
    >
      +
    </button>
  </div>
</template>

<script>

export default {
  name: 'IncrementInput',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 20,
    },
    step: {
      type: Number,
      default: 1,
    },
    readonly:{
        type: Boolean,
        default: true,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {
    increment() {
      const next = this.internalValue + this.step;
      if (next <= this.max) {
        this.internalValue = next;
      }
    },
    decrement() {
      const prev = this.internalValue - this.step;
      if (prev >= this.min) {
        this.internalValue = prev;
      }
    },
    onInput(event) {
        const val = parseFloat(event.target.value);
        if (!isNaN(val)) {
            this.internalValue = val;
        } else {
            this.internalValue = this.min;
        }
    }
  },
};
</script>

<style scoped>

</style>
